import type { ConsumablesMatrixData } from "../types/ConsumablesMatrix";

export const getConsumablesMatrixDataMock = (): ConsumablesMatrixData => ({
  packagingFormats: [
    {
      id: "pack-one-flavor",
      label: "Pack One Flavor",
      contentsType: "pack",
      itemsPerPackage: 20,
      formatQuantity: 20,
      productTypeName: "SimpleProduct",
      icon: "https://example.com/icon.png",
    },
    {
      id: "carton-one-flavor",
      label: "Carton one flavor",
      contentsType: "carton",
      itemsPerPackage: 20,
      formatQuantity: 10,
      packagesPerBundle: 10,
      productTypeName: "BundleProduct",
      icon: "https://example.com/icon.png",
    },
    {
      id: "carton-mix-and-match",
      label: "Carton mix and match",
      contentsType: "mixed",
      itemsPerPackage: 20,
      formatQuantity: 10,
      packagesPerBundle: 5,
      productTypeName: "BundleProduct",
      icon: "https://example.com/icon.png",
    },
  ],
  items: [
    {
      sku: "sticks-pack-gold",
      packagingFormatId: "pack-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "13",
        flavour_label: "Gold",
        swatch_data: "#cfc613",
      },
      product: {
        id: 13600,
        name: "Camel Gold - Pack",
        updatedAt: "2024-11-11 11:50:32",
        color: 39,
        colorName: "Gold",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-pack-gold",
        description:
          '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: [],
            label: null,
            position: 1,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_1.jpg",
            disabled: false,
            videoContentDto: null,
          },
          {
            type: "image",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
            label: null,
            position: 0,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-pack-1",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Pack"],
          "Dynamic Bundle": ["/c/a/camel_gold.png"],
          Flavor: ["Gold"],
          Colour: ["Gold"],
        },
        bundle: false,
        productBundleConfiguration: null,
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "13",
            name: "Gold",
            description: "Rich as Bezos",
            attributes_custom_: [
              {
                id: "5",
                name: "Intensity",
                value: "4.5",
                sort_order: "8",
              },
              {
                id: "6",
                name: "Flavor",
                value: "1.5",
                sort_order: "9",
              },
              {
                id: "7",
                name: "Strength",
                value: "4.5",
                sort_order: "10",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-pack-silver",
      packagingFormatId: "pack-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "15",
        flavour_label: "Silver",
        swatch_data: "#acacac",
      },
      product: {
        id: 13601,
        name: "Camel Silver - Pack",
        updatedAt: "2024-10-09 17:56:01",
        color: 18,
        colorName: "Silver",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-pack-silver",
        description:
          '&lt;p>&lt;span>Camel Silver tobacco fillings have a very fine and harmonious taste of tobacco with sweet and subtle aromatic undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity – the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
            label: null,
            position: 4,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-pack-2",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Pack"],
          "Dynamic Bundle": ["/c/a/camel_silver.png"],
          Flavor: ["Silver"],
          Colour: ["Silver"],
        },
        bundle: false,
        productBundleConfiguration: null,
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "15",
            name: "Silver",
            description: "Fresh kick",
            attributes_custom_: [
              {
                id: "9",
                name: "Intensity",
                value: "4.5",
                sort_order: "17",
              },
              {
                id: "10",
                name: "Flavor",
                value: "1.5",
                sort_order: "18",
              },
              {
                id: "11",
                name: "Strength",
                value: "2.5",
                sort_order: "19",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-pack-tan",
      packagingFormatId: "pack-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "37",
        flavour_label: "Tan",
        swatch_data: "#e0d561",
      },
      product: {
        id: 13606,
        name: "Camel Tan - Pack",
        updatedAt: "2024-11-01 12:33:56",
        color: 27,
        colorName: "Camel",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-pack-tan",
        description:
          '&lt;p>&lt;span>Camel Tan tobacco refills have a sweet and full tobacco taste. Prominent tobacco notes are perfectly balanced by an ingenious combination of sweet, vanilla and caramel undertones. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
            label: null,
            position: 0,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-pack-4",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Pack"],
          "Dynamic Bundle": ["/c/a/camel_tan.png"],
          Flavor: ["Tan"],
          Colour: ["Camel"],
        },
        bundle: false,
        productBundleConfiguration: null,
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "37",
            name: "Tan",
            description: "Power of grass torn from the ground",
            attributes_custom_: [
              {
                id: "17",
                name: "Intensity",
                value: "1.5",
                sort_order: "27",
              },
              {
                id: "18",
                name: "Flavor",
                value: "2.5",
                sort_order: "28",
              },
              {
                id: "19",
                name: "Strength",
                value: "1.5",
                sort_order: "29",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-pack-burgundy",
      packagingFormatId: "pack-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "40",
        flavour_label: "Burgundy",
        swatch_data: "#9e091b",
      },
      product: {
        id: 13608,
        name: "Camel Burgundy - Pack",
        updatedAt: "2024-10-09 17:50:23",
        color: 38,
        colorName: "Diamond",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-pack-burgundy",
        description:
          '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail", "swatch_image"],
            label: null,
            position: 7,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-pack-5",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Pack"],
          "Dynamic Bundle": ["no_selection"],
          Flavor: ["Burgundy"],
          Colour: ["Diamond"],
        },
        bundle: false,
        productBundleConfiguration: null,
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "40",
            name: "Burgundy",
            description: "Bloody Mary",
            attributes_custom_: [
              {
                id: "21",
                name: "Intensity",
                value: "4.5",
                sort_order: "32",
              },
              {
                id: "22",
                name: "Flavor",
                value: "3.5",
                sort_order: "33",
              },
              {
                id: "23",
                name: "Strength",
                value: "3",
                sort_order: "34",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "pack-for-broken-bundle-carton",
      packagingFormatId: "pack-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "2137",
        flavour_label: "Gold",
        swatch_data: "#cfc613",
      },
      product: {
        id: 13600,
        name: "Camel Gold - Pack",
        updatedAt: "2024-11-11 11:50:32",
        color: 39,
        colorName: "Gold",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-pack-gold",
        description:
          '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: [],
            label: null,
            position: 1,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_1.jpg",
            disabled: false,
            videoContentDto: null,
          },
          {
            type: "image",
            role: ["image", "small_image", "thumbnail", "swatch_image", "dynamic_picture_bundle"],
            label: null,
            position: 0,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-pack-1",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Pack"],
          "Dynamic Bundle": ["/c/a/camel_gold.png"],
          Flavor: ["Gold"],
          Colour: ["Gold"],
        },
        bundle: false,
        productBundleConfiguration: null,
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "13",
            name: "Gold",
            description: "Rich as Bezos",
            attributes_custom_: [
              {
                id: "5",
                name: "Intensity",
                value: "4.5",
                sort_order: "8",
              },
              {
                id: "6",
                name: "Flavor",
                value: "1.5",
                sort_order: "9",
              },
              {
                id: "7",
                name: "Strength",
                value: "4.5",
                sort_order: "10",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-gold",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "13",
        flavour_label: "Gold",
        swatch_data: "#cfc613",
      },
      product: {
        id: 13602,
        name: "Camel Gold - Carton",
        updatedAt: "2024-10-09 17:55:16",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-gold",
        description:
          '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 2,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_2.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_2.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_2.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-1",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Flavor: ["Gold"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [
                {
                  id: 4848,
                  isDefault: true,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: "Gold",
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: [],
                    categories: [],
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: [],
                    variants: [],
                    configurableOptions: [],
                    frontendAttributes: {},
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: {},
                    tierPrices: [],
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              allOptions: [
                {
                  id: 4848,
                  isDefault: true,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: null,
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4713,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-gold",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "13",
            name: "Gold",
            description: "Rich as Bezos",
            attributes_custom_: [
              {
                id: "5",
                name: "Intensity",
                value: "4.5",
                sort_order: "8",
              },
              {
                id: "6",
                name: "Flavor",
                value: "1.5",
                sort_order: "9",
              },
              {
                id: "7",
                name: "Strength",
                value: "4.5",
                sort_order: "10",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-silver",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "15",
        flavour_label: "Silver",
        swatch_data: "#acacac",
      },
      product: {
        id: 13603,
        name: "Camel Silver - Carton",
        updatedAt: "2024-10-09 17:54:36",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-silver",
        description:
          '&lt;p>&lt;span>Camel Silver tobacco fillings have a very fine and harmonious taste of tobacco with sweet and subtle aromatic undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity – the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 3,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-2",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Flavor: ["Silver"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [],
              allOptions: [
                {
                  id: 4849,
                  isDefault: true,
                  label: "Camel Silver - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#acacac",
                  product: {
                    id: 13601,
                    name: "Camel Silver - Pack",
                    updatedAt: null,
                    color: 18,
                    colorName: null,
                    flavor: "15",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-silver",
                    description:
                      '&lt;p>&lt;span>Camel Silver tobacco fillings have a very fine and harmonious taste of tobacco with sweet and subtle aromatic undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity – the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "15",
                        name: "Silver",
                        description: "Fresh kick",
                        attributes_custom_: [
                          {
                            id: "9",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "17",
                          },
                          {
                            id: "10",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "18",
                          },
                          {
                            id: "11",
                            name: "Strength",
                            value: "2.5",
                            sort_order: "19",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4714,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-silver",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "15",
            name: "Silver",
            description: "Fresh kick",
            attributes_custom_: [
              {
                id: "9",
                name: "Intensity",
                value: "4.5",
                sort_order: "17",
              },
              {
                id: "10",
                name: "Flavor",
                value: "1.5",
                sort_order: "18",
              },
              {
                id: "11",
                name: "Strength",
                value: "2.5",
                sort_order: "19",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-amber",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "16",
        flavour_label: "Amber",
        swatch_data: "#b3022e",
      },
      product: {
        id: 13605,
        name: "Camel Amber - Carton",
        updatedAt: "2024-10-09 17:53:02",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-amber",
        description:
          '&lt;p>&lt;span>Camel Amber tobacco fillings have a full and balanced flavor with woody, creamy and coffee undertones with a lingering sweet aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 4,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/4/_/4_2.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-3",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Flavor: ["Amber"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [],
              allOptions: [
                {
                  id: 4850,
                  isDefault: true,
                  label: "Camel Amber - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#b3022e",
                  product: {
                    id: 13604,
                    name: "Camel Amber - Pack",
                    updatedAt: null,
                    color: 29,
                    colorName: null,
                    flavor: "16",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-amber",
                    description:
                      '&lt;p>&lt;span>Camel Amber tobacco fillings have a full and balanced flavor with woody, creamy and coffee undertones with a lingering sweet aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "This is a test for the tooltip info",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "16",
                        name: "Amber",
                        description: "Stronger fresh kick",
                        attributes_custom_: [
                          {
                            id: "13",
                            name: "Intensity",
                            value: "0.5",
                            sort_order: "22",
                          },
                          {
                            id: "14",
                            name: "Flavor",
                            value: "4.5",
                            sort_order: "23",
                          },
                          {
                            id: "15",
                            name: "Strength",
                            value: "2.5",
                            sort_order: "24",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4715,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-amber",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "16",
            name: "Amber",
            description: "Stronger fresh kick",
            attributes_custom_: [
              {
                id: "13",
                name: "Intensity",
                value: "0.5",
                sort_order: "22",
              },
              {
                id: "14",
                name: "Flavor",
                value: "4.5",
                sort_order: "23",
              },
              {
                id: "15",
                name: "Strength",
                value: "2.5",
                sort_order: "24",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-tan",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "37",
        flavour_label: "Tan",
        swatch_data: "#e0d561",
      },
      product: {
        id: 13607,
        name: "Camel Tan - Carton",
        updatedAt: "2024-10-09 17:51:03",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-tan",
        description:
          '&lt;p>&lt;span>Camel Tan tobacco refills have a sweet and full tobacco taste. Prominent tobacco notes are perfectly balanced by an ingenious combination of sweet, vanilla and caramel undertones. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 5,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/5/_/5_2.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/5/_/5_2.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/5/_/5_2.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-4",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Flavor: ["Tan"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [],
              allOptions: [
                {
                  id: 4852,
                  isDefault: true,
                  label: "Camel Tan - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#e0d561",
                  product: {
                    id: 13606,
                    name: "Camel Tan - Pack",
                    updatedAt: null,
                    color: 27,
                    colorName: null,
                    flavor: "37",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-tan",
                    description:
                      '&lt;p>&lt;span>Camel Tan tobacco refills have a sweet and full tobacco taste. Prominent tobacco notes are perfectly balanced by an ingenious combination of sweet, vanilla and caramel undertones. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "37",
                        name: "Tan",
                        description: "Power of grass torn from the ground",
                        attributes_custom_: [
                          {
                            id: "17",
                            name: "Intensity",
                            value: "1.5",
                            sort_order: "27",
                          },
                          {
                            id: "18",
                            name: "Flavor",
                            value: "2.5",
                            sort_order: "28",
                          },
                          {
                            id: "19",
                            name: "Strength",
                            value: "1.5",
                            sort_order: "29",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4717,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-tan",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "37",
            name: "Tan",
            description: "Power of grass torn from the ground",
            attributes_custom_: [
              {
                id: "17",
                name: "Intensity",
                value: "1.5",
                sort_order: "27",
              },
              {
                id: "18",
                name: "Flavor",
                value: "2.5",
                sort_order: "28",
              },
              {
                id: "19",
                name: "Strength",
                value: "1.5",
                sort_order: "29",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "carton-with-broken-bundle-config",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "regular",
      flavorDetails: {
        flavour: "2137",
        flavour_label: "Winston sticks rich",
        swatch_data: "#FF0000",
      },
      product: {
        id: 12851,
        name: "TEST Sticks Selector Matrix Product 25",
        updatedAt: "2024-05-02 14:51:48",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "test-sticks-selector-matrix-product-25",
        description: "&lt;p>TEST Sticks Selector Matrix Product 1&lt;/p>",
        mediaGallery: [
          {
            type: "image",
            label: null,
            position: 2,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/s/c/screenshot_2024-05-02_at_16.46.32.png",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 42,
            name: "Acquista",
          },
          {
            id: 43,
            name: "Device",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/s/c/screenshot_2024-05-02_at_16.46.32.png",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/s/c/screenshot_2024-05-02_at_16.46.32.png",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "test-simple-product-2-4-6-p1-8",
        multiPackEnabled: true,
        multiPackLabel: "TEST Simple product 2.4.6-p1 Label",
        multiPackDescription: "TEST Simple product 2.4.6-p1 Description",
        multiPackProducts: [
          {
            sku: "test-bundle-product-2-4-6-p1",
            name: "TEST Bundle product 2.4.6-p1",
            label: "TEST Bundle product 2.4.6-p1 Label",
            description: "TEST Bundle product 2.4.6-p1 Description",
          },
          {
            sku: "test-configurable-product-2-4-6-p1",
            name: "TEST Configurable product 2.4.6-p1",
            label: "TEST Configurable product 2.4.6-p1 Label",
            description: "TEST Configurable product 2.4.6-p1 Description",
          },
        ],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          "Input terminal": ["USB-C"],
          "Device dimensions": ["L 15.3cm W 7.5cm D 2.9cm"],
          Battery: ["5 V"],
          Flavor: ["Winston sticks rich"],
          Weight: ["0.154 kgs"],
          "Subscription Format": ["Carton"],
        },
        bundle: false,
        productBundleConfiguration: {
          items: [
            {
              optionsString: "",
              allOptionsString: "",
              options: [],
              allOptions: [],
              optionId: 4652,
              title: "packs",
              type: "multi",
              sku: "pack-for-broken-bundle-carton",
              qty: 10,
            },
          ],
        },
        specification: {
          battery: "5 V",
          weight: "0.154",
        },
        tierPrices: [],
        flavorDetails: [
          {
            id: "14",
            name: "Bronze",
            description: "Smoother than you think",
            attributes_custom_: [
              {
                id: "1",
                name: "Intensity",
                value: "2",
                sort_order: "3",
              },
              {
                id: "2",
                name: "Flavor",
                value: "4",
                sort_order: "4",
              },
              {
                id: "3",
                name: "Strength",
                value: "1",
                sort_order: "5",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-gold-subscription",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "subscription",
      flavorDetails: {
        flavour: "13",
        flavour_label: "Gold",
        swatch_data: "#cfc613",
      },
      product: {
        id: 13614,
        name: "Camel Gold - Carton - Subscription",
        updatedAt: "2024-11-11 11:49:42",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-gold-subscription",
        description:
          '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 2,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_2_1.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_2_1.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_2_1.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-10",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Subscription: ["1"],
          Flavor: ["Gold"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [
                {
                  id: 4737,
                  isDefault: true,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: "Gold",
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: [],
                    categories: [],
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: [],
                    variants: [],
                    configurableOptions: [],
                    frontendAttributes: {},
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: {},
                    tierPrices: [],
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              allOptions: [
                {
                  id: 4737,
                  isDefault: true,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: null,
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4652,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-gold-subscription",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "13",
            name: "Gold",
            description: "Rich as Bezos",
            attributes_custom_: [
              {
                id: "5",
                name: "Intensity",
                value: "4.5",
                sort_order: "8",
              },
              {
                id: "6",
                name: "Flavor",
                value: "1.5",
                sort_order: "9",
              },
              {
                id: "7",
                name: "Strength",
                value: "4.5",
                sort_order: "10",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-silver-subscription",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "subscription",
      flavorDetails: {
        flavour: "15",
        flavour_label: "Silver",
        swatch_data: "#acacac",
      },
      product: {
        id: 13613,
        name: "Camel Silver - Carton - Subscription",
        updatedAt: "2024-10-09 17:40:18",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-silver-subscription",
        description:
          '&lt;p>&lt;span>Camel Silver tobacco fillings have a very fine and harmonious taste of tobacco with sweet and subtle aromatic undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity – the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 3,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/3/_/3_2_1.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-9",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Subscription: ["1"],
          Flavor: ["Silver"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [],
              allOptions: [
                {
                  id: 4736,
                  isDefault: false,
                  label: "Camel Silver - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#acacac",
                  product: {
                    id: 13601,
                    name: "Camel Silver - Pack",
                    updatedAt: null,
                    color: 18,
                    colorName: null,
                    flavor: "15",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-silver",
                    description:
                      '&lt;p>&lt;span>Camel Silver tobacco fillings have a very fine and harmonious taste of tobacco with sweet and subtle aromatic undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity – the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "15",
                        name: "Silver",
                        description: "Fresh kick",
                        attributes_custom_: [
                          {
                            id: "9",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "17",
                          },
                          {
                            id: "10",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "18",
                          },
                          {
                            id: "11",
                            name: "Strength",
                            value: "2.5",
                            sort_order: "19",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4651,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-silver-subscription",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "15",
            name: "Silver",
            description: "Fresh kick",
            attributes_custom_: [
              {
                id: "9",
                name: "Intensity",
                value: "4.5",
                sort_order: "17",
              },
              {
                id: "10",
                name: "Flavor",
                value: "1.5",
                sort_order: "18",
              },
              {
                id: "11",
                name: "Strength",
                value: "2.5",
                sort_order: "19",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-tan-subscription",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "subscription",
      flavorDetails: {
        flavour: "37",
        flavour_label: "Tan",
        swatch_data: "#e0d561",
      },
      product: {
        id: 13611,
        name: "Camel Tan - Carton - Subscription",
        updatedAt: "2024-11-01 12:40:02",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-tan-subscription",
        description:
          '&lt;p>&lt;span>Camel Tan tobacco refills have a sweet and full tobacco taste. Prominent tobacco notes are perfectly balanced by an ingenious combination of sweet, vanilla and caramel undertones. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 5,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/5/_/5_2_1.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/5/_/5_2_1.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/5/_/5_2_1.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-7",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Subscription: ["1"],
          Flavor: ["Tan"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [],
              allOptions: [
                {
                  id: 4734,
                  isDefault: true,
                  label: "Camel Tan - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#e0d561",
                  product: {
                    id: 13606,
                    name: "Camel Tan - Pack",
                    updatedAt: null,
                    color: 27,
                    colorName: null,
                    productBrand: null,
                    flavor: "37",
                    flavorLabel: null,
                    sku: "sticks-pack-tan",
                    description:
                      '&lt;p>&lt;span>Camel Tan tobacco refills have a sweet and full tobacco taste. Prominent tobacco notes are perfectly balanced by an ingenious combination of sweet, vanilla and caramel undertones. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "37",
                        name: "Tan",
                        description: "Power of grass torn from the ground",
                        attributes_custom_: [
                          {
                            id: "17",
                            name: "Intensity",
                            value: "1.5",
                            sort_order: "27",
                          },
                          {
                            id: "18",
                            name: "Flavor",
                            value: "2.5",
                            sort_order: "28",
                          },
                          {
                            id: "19",
                            name: "Strength",
                            value: "1.5",
                            sort_order: "29",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4649,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-tan-subscription",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "37",
            name: "Tan",
            description: "Power of grass torn from the ground",
            attributes_custom_: [
              {
                id: "17",
                name: "Intensity",
                value: "1.5",
                sort_order: "27",
              },
              {
                id: "18",
                name: "Flavor",
                value: "2.5",
                sort_order: "28",
              },
              {
                id: "19",
                name: "Strength",
                value: "1.5",
                sort_order: "29",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-carton-burgundy-subscription",
      packagingFormatId: "carton-one-flavor",
      purchaseType: "subscription",
      flavorDetails: {
        flavour: "40",
        flavour_label: "Burgundy",
        swatch_data: "#9e091b",
      },
      product: {
        id: 13610,
        name: "Camel Burgundy - Carton - Subscription",
        updatedAt: "2024-11-11 13:08:23",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-carton-burgundy-subscription",
        description:
          '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>You will find 10 Camel boxes in a carton and each of them contains 20 pieces of tobacco fillings.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>The Camel brand continues a more than century-old tradition of processing the highest quality tobacco. Thanks to the well-known &lt;/span>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> , the well-known box with a camel became widely known. And because not only the depiction of this exotic animal goes with the times, you can also enjoy &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;/a>&lt;span> in a modern and gentler way. Just choose the fillings and flavors you like.&lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail"],
            label: null,
            position: 6,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/6/_/6_1_1.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [
          {
            id: 44,
            name: "Products",
          },
        ],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/6/_/6_1_1.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/6/_/6_1_1.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "camel-bronze-carton-6",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Carton"],
          Subscription: ["1"],
          Flavor: ["Burgundy"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [
                {
                  id: 4733,
                  isDefault: false,
                  label: "Camel Burgundy - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#9e091b",
                  product: {
                    id: 13608,
                    name: "Camel Burgundy - Pack",
                    updatedAt: null,
                    color: 38,
                    colorName: "Diamond",
                    flavor: "40",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-burgundy",
                    description:
                      '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: [],
                    categories: [],
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: [],
                    variants: [],
                    configurableOptions: [],
                    frontendAttributes: {},
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: {},
                    tierPrices: [],
                    flavorDetails: [
                      {
                        id: "40",
                        name: "Burgundy",
                        description: "Bloody Mary",
                        attributes_custom_: [
                          {
                            id: "21",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "32",
                          },
                          {
                            id: "22",
                            name: "Flavor",
                            value: "3.5",
                            sort_order: "33",
                          },
                          {
                            id: "23",
                            name: "Strength",
                            value: "3",
                            sort_order: "34",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              allOptions: [
                {
                  id: 4733,
                  isDefault: false,
                  label: "Camel Burgundy - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 10.0,
                  swatchData: "#9e091b",
                  product: {
                    id: 13608,
                    name: "Camel Burgundy - Pack",
                    updatedAt: null,
                    color: 38,
                    colorName: null,
                    flavor: "40",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-burgundy",
                    description:
                      '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "40",
                        name: "Burgundy",
                        description: "Bloody Mary",
                        attributes_custom_: [
                          {
                            id: "21",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "32",
                          },
                          {
                            id: "22",
                            name: "Flavor",
                            value: "3.5",
                            sort_order: "33",
                          },
                          {
                            id: "23",
                            name: "Strength",
                            value: "3",
                            sort_order: "34",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4648,
              title: "packs",
              type: "multi",
              sku: "sticks-carton-burgundy-subscription",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "40",
            name: "Burgundy",
            description: "Bloody Mary",
            attributes_custom_: [
              {
                id: "21",
                name: "Intensity",
                value: "4.5",
                sort_order: "32",
              },
              {
                id: "22",
                name: "Flavor",
                value: "3.5",
                sort_order: "33",
              },
              {
                id: "23",
                name: "Strength",
                value: "3",
                sort_order: "34",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-mix-n-match",
      packagingFormatId: "carton-mix-and-match",
      purchaseType: "regular",
      flavorDetails: {
        flavour: null,
        flavour_label: null,
        swatch_data: null,
      },
      product: {
        id: 13616,
        name: "Carton Mix & Match",
        updatedAt: "2024-10-09 17:31:23",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-mix-n-match",
        description:
          '&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco. The carton contains 10 Camel boxes. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-gold">&lt;span>Gold&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-bronze">&lt;span>Bronze&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-silver">&lt;span>Silver&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-tan">&lt;span>Tan&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-amber">&lt;span>Amber&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-burgundy">&lt;span>Burgundy&lt;/span>&lt;/a>&lt;/p>\r\n&lt;p>&lt;span>Tobacco - A classic choice for true tobacco lovers, whether you prefer mild and light tobacco, rich and intense tobacco, or something in between.&lt;/span>&lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-teal">&lt;span>Teal&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-aquamarine">&lt;span>Aquamarine&lt;/span>&lt;/a>&lt;/p>\r\n&lt;p>&lt;span>Fresh news - A fresh combination of fine, aromatic tobacco flavor with cooling notes.&lt;/span>&lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-yellow">&lt;span>Yellow&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-garnet">&lt;span>Garnet&lt;/span>&lt;/a>&lt;/p>\r\n&lt;p>&lt;span>Spring news - Combination of fine tobacco taste with refreshing citrus and sweet floral notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>Our signature ActivBlend blend is made from high-quality Virgina, Burley and Oriental tobacco leaves with an added tobacco layer to deliver an even more authentic taste of real tobacco. The entire process of making &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute">&lt;span>Camel tobacco refills&lt;/span>&lt;/a>&lt;span> , from the growers who care for the seeds to the final quality control, is a journey of careful selection, expertise and perfection. To achieve a rich range of flavors, we take care of the tobacco and add flavors that give it taste notes from rich tobacco to icy menthol. &lt;/span>&lt;/p>\r\n&lt;p>&lt;span>One box contains 20 pieces of your favorite fillings. &lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail", "dynamic_picture_bundle"],
            label: null,
            position: 1,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/m/n/mnm.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/m/n/mnm.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/m/n/mnm.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "helloo",
        metaDescription: "Carton Mix&#39;n&#39;Match ",
        metaTitle: "Carton Mix&#39;n&#39;Match",
        urlKey: "carton-mix-n-match",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Mix and Match"],
          trabka: ["hello"],
          "Dynamic Bundle": ["/m/n/mnm.jpg"],
          Flavor: ["Silver"],
          "Tooltip Info": ["helloo"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [
                {
                  id: 4740,
                  isDefault: false,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: "Gold",
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: [],
                    categories: [],
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: [],
                    variants: [],
                    configurableOptions: [],
                    frontendAttributes: {},
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: {},
                    tierPrices: [],
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4744,
                  isDefault: false,
                  label: "Camel Burgundy - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#9e091b",
                  product: {
                    id: 13608,
                    name: "Camel Burgundy - Pack",
                    updatedAt: null,
                    color: 38,
                    colorName: "Diamond",
                    flavor: "40",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-burgundy",
                    description:
                      '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: [],
                    categories: [],
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: [],
                    variants: [],
                    configurableOptions: [],
                    frontendAttributes: {},
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: {},
                    tierPrices: [],
                    flavorDetails: [
                      {
                        id: "40",
                        name: "Burgundy",
                        description: "Bloody Mary",
                        attributes_custom_: [
                          {
                            id: "21",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "32",
                          },
                          {
                            id: "22",
                            name: "Flavor",
                            value: "3.5",
                            sort_order: "33",
                          },
                          {
                            id: "23",
                            name: "Strength",
                            value: "3",
                            sort_order: "34",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              allOptions: [
                {
                  id: 4740,
                  isDefault: false,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: null,
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4741,
                  isDefault: false,
                  label: "Camel Silver - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#acacac",
                  product: {
                    id: 13601,
                    name: "Camel Silver - Pack",
                    updatedAt: null,
                    color: 18,
                    colorName: null,
                    flavor: "15",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-silver",
                    description:
                      '&lt;p>&lt;span>Camel Silver tobacco fillings have a very fine and harmonious taste of tobacco with sweet and subtle aromatic undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity – the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "15",
                        name: "Silver",
                        description: "Fresh kick",
                        attributes_custom_: [
                          {
                            id: "9",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "17",
                          },
                          {
                            id: "10",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "18",
                          },
                          {
                            id: "11",
                            name: "Strength",
                            value: "2.5",
                            sort_order: "19",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4742,
                  isDefault: false,
                  label: "Camel Amber - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#b3022e",
                  product: {
                    id: 13604,
                    name: "Camel Amber - Pack",
                    updatedAt: null,
                    color: 29,
                    colorName: null,
                    flavor: "16",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-amber",
                    description:
                      '&lt;p>&lt;span>Camel Amber tobacco fillings have a full and balanced flavor with woody, creamy and coffee undertones with a lingering sweet aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "This is a test for the tooltip info",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "16",
                        name: "Amber",
                        description: "Stronger fresh kick",
                        attributes_custom_: [
                          {
                            id: "13",
                            name: "Intensity",
                            value: "0.5",
                            sort_order: "22",
                          },
                          {
                            id: "14",
                            name: "Flavor",
                            value: "4.5",
                            sort_order: "23",
                          },
                          {
                            id: "15",
                            name: "Strength",
                            value: "2.5",
                            sort_order: "24",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4743,
                  isDefault: false,
                  label: "Camel Tan - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#e0d561",
                  product: {
                    id: 13606,
                    name: "Camel Tan - Pack",
                    updatedAt: null,
                    color: 27,
                    colorName: null,
                    flavor: "37",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-tan",
                    description:
                      '&lt;p>&lt;span>Camel Tan tobacco refills have a sweet and full tobacco taste. Prominent tobacco notes are perfectly balanced by an ingenious combination of sweet, vanilla and caramel undertones. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "37",
                        name: "Tan",
                        description: "Power of grass torn from the ground",
                        attributes_custom_: [
                          {
                            id: "17",
                            name: "Intensity",
                            value: "1.5",
                            sort_order: "27",
                          },
                          {
                            id: "18",
                            name: "Flavor",
                            value: "2.5",
                            sort_order: "28",
                          },
                          {
                            id: "19",
                            name: "Strength",
                            value: "1.5",
                            sort_order: "29",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4744,
                  isDefault: false,
                  label: "Camel Burgundy - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#9e091b",
                  product: {
                    id: 13608,
                    name: "Camel Burgundy - Pack",
                    updatedAt: null,
                    color: 38,
                    colorName: null,
                    flavor: "40",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-burgundy",
                    description:
                      '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "40",
                        name: "Burgundy",
                        description: "Bloody Mary",
                        attributes_custom_: [
                          {
                            id: "21",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "32",
                          },
                          {
                            id: "22",
                            name: "Flavor",
                            value: "3.5",
                            sort_order: "33",
                          },
                          {
                            id: "23",
                            name: "Strength",
                            value: "3",
                            sort_order: "34",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4654,
              title: "sticks",
              type: "multi",
              sku: "sticks-mix-n-match",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "15",
            name: "Silver",
            description: "Fresh kick",
            attributes_custom_: [
              {
                id: "9",
                name: "Intensity",
                value: "4.5",
                sort_order: "17",
              },
              {
                id: "10",
                name: "Flavor",
                value: "1.5",
                sort_order: "18",
              },
              {
                id: "11",
                name: "Strength",
                value: "2.5",
                sort_order: "19",
              },
            ],
          },
        ],
      },
    },
    {
      sku: "sticks-mix-n-match-subscription",
      packagingFormatId: "carton-mix-and-match",
      purchaseType: "subscription",
      flavorDetails: {
        flavour: null,
        flavour_label: null,
        swatch_data: null,
      },
      product: {
        id: 13617,
        name: "Carton Mix & Match - Subscription",
        updatedAt: "2024-10-31 08:11:53",
        color: null,
        colorName: "",
        flavor: "",
        flavorLabel: null,
        sku: "sticks-mix-n-match-subscription",
        description:
          '&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco. The carton contains 10 Camel boxes. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-gold">&lt;span>Gold&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-bronze">&lt;span>Bronze&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-silver">&lt;span>Silver&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-tan">&lt;span>Tan&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-amber">&lt;span>Amber&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-burgundy">&lt;span>Burgundy&lt;/span>&lt;/a>&lt;/p>\r\n&lt;p>&lt;span>Tobacco - A classic choice for true tobacco lovers, whether you prefer mild and light tobacco, rich and intense tobacco, or something in between.&lt;/span>&lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-teal">&lt;span>Teal&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-aquamarine">&lt;span>Aquamarine&lt;/span>&lt;/a>&lt;/p>\r\n&lt;p>&lt;span>Fresh news - A fresh combination of fine, aromatic tobacco flavor with cooling notes.&lt;/span>&lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-yellow">&lt;span>Yellow&lt;/span>&lt;/a>&lt;span> , &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute/camel-krabicka-garnet">&lt;span>Garnet&lt;/span>&lt;/a>&lt;/p>\r\n&lt;p>&lt;span>Spring news - Combination of fine tobacco taste with refreshing citrus and sweet floral notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>Our signature ActivBlend blend is made from high-quality Virgina, Burley and Oriental tobacco leaves with an added tobacco layer to deliver an even more authentic taste of real tobacco. The entire process of making &lt;/span>&lt;a href="https://www.ploom.cz/cz/e-shop/produkty/prichute">&lt;span>Camel tobacco refills&lt;/span>&lt;/a>&lt;span> , from the growers who care for the seeds to the final quality control, is a journey of careful selection, expertise and perfection. To achieve a rich range of flavors, we take care of the tobacco and add flavors that give it taste notes from rich tobacco to icy menthol. &lt;/span>&lt;/p>\r\n&lt;p>&lt;span>One box contains 20 pieces of your favorite fillings. &lt;/span>&lt;/p>',
        mediaGallery: [
          {
            type: "image",
            role: ["image", "small_image", "thumbnail", "dynamic_picture_bundle"],
            label: null,
            position: 1,
            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/m/n/mnm_1.jpg",
            disabled: false,
            videoContentDto: null,
          },
        ],
        categories: [],
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/m/n/mnm_1.jpg",
        },
        image: {
          url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/m/n/mnm_1.jpg",
        },
        newFromDate: null,
        newToDate: null,
        tooltipInfo: "",
        metaDescription: null,
        metaTitle: null,
        urlKey: "carton-mix-n-match-1",
        multiPackEnabled: false,
        multiPackLabel: null,
        multiPackDescription: null,
        multiPackProducts: [],
        variants: [],
        configurableOptions: [],
        frontendAttributes: {
          Format: ["Mix and Match"],
          "Dynamic Bundle": ["/m/n/mnm_1.jpg"],
          Subscription: ["1"],
          Flavor: ["Silver"],
        },
        bundle: true,
        productBundleConfiguration: {
          items: [
            {
              options: [
                {
                  id: 4746,
                  isDefault: false,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: "Gold",
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: [],
                    categories: [],
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: [],
                    variants: [],
                    configurableOptions: [],
                    frontendAttributes: {},
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: {},
                    tierPrices: [],
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4750,
                  isDefault: false,
                  label: "Camel Burgundy - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#9e091b",
                  product: {
                    id: 13608,
                    name: "Camel Burgundy - Pack",
                    updatedAt: null,
                    color: 38,
                    colorName: "Diamond",
                    flavor: "40",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-burgundy",
                    description:
                      '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: [],
                    categories: [],
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: [],
                    variants: [],
                    configurableOptions: [],
                    frontendAttributes: {},
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: {},
                    tierPrices: [],
                    flavorDetails: [
                      {
                        id: "40",
                        name: "Burgundy",
                        description: "Bloody Mary",
                        attributes_custom_: [
                          {
                            id: "21",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "32",
                          },
                          {
                            id: "22",
                            name: "Flavor",
                            value: "3.5",
                            sort_order: "33",
                          },
                          {
                            id: "23",
                            name: "Strength",
                            value: "3",
                            sort_order: "34",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              allOptions: [
                {
                  id: 4746,
                  isDefault: false,
                  label: "Camel Gold - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#cfc613",
                  product: {
                    id: 13600,
                    name: "Camel Gold - Pack",
                    updatedAt: null,
                    color: 39,
                    colorName: null,
                    flavor: "13",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-gold",
                    description:
                      '&lt;p>&lt;span>Camel Gold tobacco refills have a soft and sweet tobacco taste with balanced complex undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_gold.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "13",
                        name: "Gold",
                        description: "Rich as Bezos",
                        attributes_custom_: [
                          {
                            id: "5",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "8",
                          },
                          {
                            id: "6",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "9",
                          },
                          {
                            id: "7",
                            name: "Strength",
                            value: "4.5",
                            sort_order: "10",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4747,
                  isDefault: false,
                  label: "Camel Silver - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#acacac",
                  product: {
                    id: 13601,
                    name: "Camel Silver - Pack",
                    updatedAt: null,
                    color: 18,
                    colorName: null,
                    flavor: "15",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-silver",
                    description:
                      '&lt;p>&lt;span>Camel Silver tobacco fillings have a very fine and harmonious taste of tobacco with sweet and subtle aromatic undertones.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity – the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_silver.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "15",
                        name: "Silver",
                        description: "Fresh kick",
                        attributes_custom_: [
                          {
                            id: "9",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "17",
                          },
                          {
                            id: "10",
                            name: "Flavor",
                            value: "1.5",
                            sort_order: "18",
                          },
                          {
                            id: "11",
                            name: "Strength",
                            value: "2.5",
                            sort_order: "19",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4748,
                  isDefault: false,
                  label: "Camel Amber - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#b3022e",
                  product: {
                    id: 13604,
                    name: "Camel Amber - Pack",
                    updatedAt: null,
                    color: 29,
                    colorName: null,
                    flavor: "16",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-amber",
                    description:
                      '&lt;p>&lt;span>Camel Amber tobacco fillings have a full and balanced flavor with woody, creamy and coffee undertones with a lingering sweet aftertaste.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – the intensity of the tobacco flavor &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_amber.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "This is a test for the tooltip info",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "16",
                        name: "Amber",
                        description: "Stronger fresh kick",
                        attributes_custom_: [
                          {
                            id: "13",
                            name: "Intensity",
                            value: "0.5",
                            sort_order: "22",
                          },
                          {
                            id: "14",
                            name: "Flavor",
                            value: "4.5",
                            sort_order: "23",
                          },
                          {
                            id: "15",
                            name: "Strength",
                            value: "2.5",
                            sort_order: "24",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4749,
                  isDefault: false,
                  label: "Camel Tan - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#e0d561",
                  product: {
                    id: 13606,
                    name: "Camel Tan - Pack",
                    updatedAt: null,
                    color: 27,
                    colorName: null,
                    flavor: "37",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-tan",
                    description:
                      '&lt;p>&lt;span>Camel Tan tobacco refills have a sweet and full tobacco taste. Prominent tobacco notes are perfectly balanced by an ingenious combination of sweet, vanilla and caramel undertones. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/c/a/camel_tan.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "37",
                        name: "Tan",
                        description: "Power of grass torn from the ground",
                        attributes_custom_: [
                          {
                            id: "17",
                            name: "Intensity",
                            value: "1.5",
                            sort_order: "27",
                          },
                          {
                            id: "18",
                            name: "Flavor",
                            value: "2.5",
                            sort_order: "28",
                          },
                          {
                            id: "19",
                            name: "Strength",
                            value: "1.5",
                            sort_order: "29",
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  id: 4750,
                  isDefault: false,
                  label: "Camel Burgundy - Pack",
                  position: null,
                  price: null,
                  priceType: null,
                  quantity: 1.0,
                  swatchData: "#9e091b",
                  product: {
                    id: 13608,
                    name: "Camel Burgundy - Pack",
                    updatedAt: null,
                    color: 38,
                    colorName: null,
                    flavor: "40",
                    flavorLabel: null,
                    productBrand: null,
                    sku: "sticks-pack-burgundy",
                    description:
                      '&lt;p>&lt;span>Camel Burgundy tobacco fillings have a rich, aromatic and well-balanced flavor with nutty and light sweet notes.&lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;span>- Intensity - the strength of the tobacco experience&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>- Flavor – intensity of tobacco flavor and long-lasting aftertaste. &lt;/span>&lt;/p>\r\n&lt;p> &lt;/p>\r\n&lt;p>&lt;a href="https://www.ploom.cz/cz/podpora-ploom/casto-kladene-otazky/co-je-activblend">&lt;span>ActivBlend&lt;/span>&lt;/a>&lt;span> is our unique tobacco blend designed specifically for Ploom devices. By &lt;/span>&lt;a href="https://www.ploom.cz/cz/zahrivany-tabak">&lt;span>heating the tobacco&lt;/span>&lt;/a>&lt;span> from the outside and using premium quality tobacco, it brings you more authentic and full flavor and aroma of real tobacco.&lt;/span>&lt;/p>\r\n&lt;p>&lt;span>20 pieces of Camel refills are waiting for you in one box. If you want to avoid running out of refills, you can order a whole carton, where you will find 10 boxes with 20 refills in each.&lt;/span>&lt;/p>\r\n&lt;p>&lt;strong>&lt;span>Camel tobacco&lt;/span>&lt;/strong>&lt;span> refills follow a more than century-old tradition of growing and processing the highest quality tobacco. Even though the camel on the &lt;/span>&lt;a href="https://www.ploom.cz/cz/naplne-a-prichute">&lt;span>Camel refill&lt;/span>&lt;/a>&lt;span> box has changed into a more modern guise, nothing has changed about the first-class processing of the tobacco. Enjoy the traditional flavor &lt;/span>&lt;strong>&lt;span>of Camel tobacco&lt;/span>&lt;/strong>&lt;span> at its best.&lt;/span>&lt;/p>',
                    mediaGallery: null,
                    categories: null,
                    thumbnail: {
                      url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/u/bugundi_1.png",
                    },
                    image: null,
                    newFromDate: null,
                    newToDate: null,
                    tooltipInfo: "",
                    metaDescription: null,
                    metaTitle: null,
                    urlKey: null,
                    multiPackEnabled: false,
                    multiPackLabel: null,
                    multiPackDescription: null,
                    multiPackProducts: null,
                    variants: null,
                    configurableOptions: null,
                    frontendAttributes: null,
                    bundle: false,
                    productBundleConfiguration: null,
                    specification: null,
                    tierPrices: null,
                    flavorDetails: [
                      {
                        id: "40",
                        name: "Burgundy",
                        description: "Bloody Mary",
                        attributes_custom_: [
                          {
                            id: "21",
                            name: "Intensity",
                            value: "4.5",
                            sort_order: "32",
                          },
                          {
                            id: "22",
                            name: "Flavor",
                            value: "3.5",
                            sort_order: "33",
                          },
                          {
                            id: "23",
                            name: "Strength",
                            value: "3",
                            sort_order: "34",
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
              optionId: 4655,
              title: "sticks",
              type: "multi",
              sku: "sticks-mix-n-match-subscription",
              qty: 10.0,
            },
          ],
        },
        specification: {},
        tierPrices: [],
        flavorDetails: [
          {
            id: "15",
            name: "Silver",
            description: "Fresh kick",
            attributes_custom_: [
              {
                id: "9",
                name: "Intensity",
                value: "4.5",
                sort_order: "17",
              },
              {
                id: "10",
                name: "Flavor",
                value: "1.5",
                sort_order: "18",
              },
              {
                id: "11",
                name: "Strength",
                value: "2.5",
                sort_order: "19",
              },
            ],
          },
        ],
      },
    },
  ],
});
